export default "__VITE_ASSET__DlvhMgmN__"